import {useMutation} from 'react-query';
import {client} from './ApiClient';
import {SnippetAuth} from "./SnippetAuth";

const acknowledgeAlert = ({urls, auth, alertUid}: {urls: any; auth: SnippetAuth | undefined; alertUid: string}) => {
	if (!auth)
		return Promise.reject('A snippet session key is required.')

	return client(urls.LoyaltyEngineApiUrl, 'v5/snippets/alerts/commands/acknowledge', {
		...auth,
		body: {
			AlertUid: alertUid
		}
	});
}

export default function useAcknowledgeAlert() {
	// @ts-ignore
	return useMutation(acknowledgeAlert)
}
